import { requestService } from '../helpers/request.service';

export const consulationService = {
    getConsultation,
    getInvestigations,
    getInvestigationsByConsultation,
    getInvestigationsDropdown,
    getPriceDetails,
    getDiagnostics,
    getFiles,
    getConsultationHeader,
    saveConsultation,
}

function getConsultation(params) {
    return requestService.get({
        methodName: '/Consultation/GetConsultationbyId',
        queryString: params
    });
}

function getInvestigations(params) {
    return requestService.get({
        methodName: '/Consultation/GetInvestigations',
        queryString: params
    });
}

function getInvestigationsByConsultation(params) {
    return requestService.get({
        methodName: '/Consultation/GetInvestigationsByConsultation',
        queryString: params
    });
}

function getInvestigationsDropdown(params) {
    return requestService.get({
        methodName: '/Consultation/GetInvestigationsDropDown',
        queryString: params
    });
}


function getPriceDetails(params) {
    return requestService.post({
        methodName: '/Consultation/GetPriceDetails',
        body: params
    });
}


function getDiagnostics(params) {
    return requestService.get({
        methodName: '/Consultation/GetDiagnostics',
        queryString: params
    });
}



function getFiles(params) {
    return requestService.get({
        methodName: '/Consultation/GetFiles',
        queryString: params
    });
}

function getConsultationHeader(params) {
    return requestService.get({
        methodName: '/Consultation/GetConsultationHeader',
        queryString: params
    });
}

function saveConsultation(params) {
    return requestService.formData({
        methodName: '/Consultation/SaveConsultation',
        body: params
    });
}

